import { Navigate, useLocation, useParams } from "react-router";
import { searchWithTrail } from "@/lib/visit/address";

/** Legacy links retain the register reading and land in the same native visit. */
export function ApplicantFilePage() {
  const { applicantId } = useParams();
  const { search } = useLocation();
  return <Navigate replace to={`/admin/admissions${searchWithTrail(search, applicantId ? [`applicant:${applicantId}`] : [])}`} />;
}
